import MuiCard from './card';
import MuiButton from './button';
import MuiToggleButton from './toggleButton';
import MuiToggleButtonGroup from './toggleButtonGroup';
import MuiAppBar from './appBar';
import MuiTypography from './typography';
import MuiOutlinedInput from './inputOutlined';
import MuiInputLabel from './inputLabel';
import MuiAlert from './alert';
import MuiMenuItem from './menuItem';
import MuiDivider from './divider';
import MuiPaper from './paper';
import MuiSelect from './select';
import MuiCheckbox from './checkbox';
import MuiListItemText from './listItemText';
import MuiListSubheader from './listSubheader';
import MuiMenu from './menu';
import MuiInput from './input';
import MuiList from './list';
import MuiSvgIcon from './svgIcon';
import MuiIconButton from './iconButton';
import MuiTooltip from './tooltip';
import MuiInputAdornment from './inputAdornment';
import MuiFormControlLabel from './formControlLabel';
import MuiRadio from './radio';
import MuiSwitch from './switch';
import MuiLinearProgress from './linearProgress';
import MuiLink from './link';
import MuiTabs from './tabs';
import MuiGrid from './grid';
import MuiTab from './tab';
import MuiBreadcrumbs from './breadcrumbs';
import MuiAvatar from './avatar';
import MuiAvatarGroup from './avatarGroup';
import MuiModal from './modal';
import MuiTable from './table';
import MuiTableContainer from './tableContainer';
import MuiTableCell from './tableCell';
import MuiContainer from './container';
import MuiAccordion from './accordion';
import MuiAccordionSummary from './accordionSummary';
import MuiInputBase from './inputBase';
import MuiChip from './chip';
import MuiTableRow from './tableRow';
import MuiAccordionDetails from './accordionDetails';
import MuiAutocomplete from './autocomplete';
import MuiLoadingButton from './loadingButton';
import MuiFormHelperText from './formHelperText';
import MuiStep from './step';
import MuiStepper from './stepper';
import MuiDrawer from './drawer';
import MuiSlider from './slider';
import MuiSkeleton from './skeleton';
import MuiDataGrid from './dataGrid';
import MuiBackdrop from './backdrop';
import MuiPopover from './popover';
import MuiStepLabel from './stepLabel';
const components = {
  MuiCard,
  MuiButton,
  MuiAppBar,
  MuiTypography,
  MuiToggleButton,
  MuiToggleButtonGroup,
  MuiOutlinedInput,
  MuiInputLabel,
  MuiAlert,
  MuiMenuItem,
  MuiDivider,
  MuiPaper,
  MuiSelect,
  MuiCheckbox,
  MuiListItemText,
  MuiListSubheader,
  MuiMenu,
  MuiInput,
  MuiList,
  MuiSvgIcon,
  MuiIconButton,
  MuiTooltip,
  MuiInputAdornment,
  MuiFormControlLabel,
  MuiRadio,
  MuiSwitch,
  MuiLinearProgress,
  MuiLink,
  MuiTabs,
  MuiGrid,
  MuiTab,
  MuiBreadcrumbs,
  MuiAvatar,
  MuiAvatarGroup,
  MuiModal,
  MuiTable,
  MuiTableContainer,
  MuiTableCell,
  MuiContainer,
  MuiAccordion,
  MuiAccordionSummary,
  MuiInputBase,
  MuiChip,
  MuiTableRow,
  MuiAccordionDetails,
  MuiAutocomplete,
  MuiLoadingButton,
  MuiFormHelperText,
  MuiStep,
  MuiStepper,
  MuiDrawer,
  MuiSlider,
  MuiSkeleton,
  MuiDataGrid,
  MuiBackdrop,
  MuiPopover,
  MuiStepLabel
};
export default components;